'use strict';

const React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgPersonGroupFill = (props) => React__namespace.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "M20.7 13h-7.58l-2.55 7h8.46l-.73-2h-2.78l.73-2h3.45l1.45 4h2.1l-2.55-7ZM3.3 13 .75 20h7.66l2.55-7H3.3ZM7.5 11.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM17 11.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" })
);

module.exports = SvgPersonGroupFill;
//# sourceMappingURL=PersonGroupFill.cjs.js.map
